import { FC } from "react";
import { useDialogStore } from "../state/dialog-store";
import { ConfirmDialog } from "ui";

const DialogProvider: FC = () => {
  const { closeDialog, dialog } = useDialogStore();

  if (!dialog) {
    return null;
  }

  const {
    title,
    description,
    onConfirm,
    inputValue,
    handler,
    confirmText,
    cancelText,
    sx,
  } = dialog;
  return (
    <ConfirmDialog
      title={title}
      description={description}
      onConfirm={onConfirm}
      onClose={closeDialog}
      open
      inputValue={inputValue}
      handler={handler}
      confirmText={confirmText}
      cancelText={cancelText}
      sx={sx}
    />
  );
};

export default DialogProvider;
